<template>
    <div class="paintview show-page">
        <img class="paint-bg-1" src="@/assets/index/paintview/bg1.png" alt="">
        <img class="mobile-state paint-mobile-line zoomIn" src="@/assets/index/milestone/mobileline.png" alt="">

        <div class="paintview-body show-page">
            <img class="paint-line zoomIn pc-state" src="@/assets/index/milestone/milestone3.png" alt="">
            <div class="paintview-height">
                <ul class="paint-list">
                    <li @click="selectDetail(idx)" v-for="(item, idx) in files" :key="idx">
                        <div class="paint-list-title bounceUpIn" :style="`animation-delay:${getDt(idx)}s`">
                            <div class="list-active" :style="`transform-origin:left center;transform:scale(${selectIdx == idx ? 1 : 0})`"></div>
                            <div class="h1 bold">{{item.title}}</div>
                        </div>
                    </li>
                </ul>
                
                <div class="paint-detail bounceUpIn" :style="`animation-delay:${getDt(3)}s`">
                    <div v-if="selectIdx == 0" key="0" class="paint-detail-box">
                        <div class="t1 bold title bounceUpIn" >
                            {{files[0].title}}
                        </div>
                        <div class="h3 content bounceUpIn" :style="`animation-delay:${getDt(1)}s`">
                            {{files[0].content}}
                        </div>
                    </div>
                    <div v-else-if="selectIdx == 1" key="1" class="paint-detail-box">
                        <div class="t1 bold title bounceUpIn">
                            {{files[1].title}}
                        </div>
                        <div class="h3 content bounceUpIn" :style="`animation-delay:${getDt(1)}s`">
                            {{files[1].content}}
                        </div>
                    </div>
                    <div v-else-if="selectIdx == 2" key="2" class="paint-detail-box">
                        <div class="t1 bold title bounceUpIn">
                            {{files[2].title}}
                        </div>
                        <div class="h3 content bounceUpIn" :style="`animation-delay:${getDt(1)}s`">
                            {{files[2].content}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="paintview-pic show-page">
            <div class="paintview-pic-box">
                <transition name="fadeMask">
                    <div v-if="selectIdx == 0" key="0">
                        <div class="paintview-bottom" :style="`background: url(${require(`@/assets/index/paintview/paint1.png`)});background-size:cover`"></div>
                        <div class="paintview-cover draw-pic" :style="`background: url(${require(`@/assets/index/paintview/paint1g.png`)});background-size:cover`"></div>
                    </div>
                    <div v-else-if="selectIdx == 1" key="1">
                        <div class="paintview-bottom" :style="`background: url(${require(`@/assets/index/paintview/paint2.png`)});background-size:cover`"></div>
                        <div class="paintview-cover draw-pic" :style="`background: url(${require(`@/assets/index/paintview/paint2g.png`)});background-size:cover`"></div>
                    </div>
                    <div v-else-if="selectIdx == 2" key="2">
                        <div class="paintview-bottom" :style="`background: url(${require(`@/assets/index/paintview/paint3.png`)});background-size:cover`"></div>
                        <div class="paintview-cover draw-pic" :style="`background: url(${require(`@/assets/index/paintview/paint3g.png`)});background-size:cover`"></div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data(){
        return {
            liststart : 0.1,
            listdt : 0.1,

            selectIdx : 0,
            files:[
                {title:`NFT Creator`, content:`Get rewarded for your fabulous creations.  Users can design and mint their own NFTs to be used in the MOMOverse.  Original creators receive lifetime trading fees for their NFT creations. `},
                {title:`Game Creator`, content:`Easily launch your blockchain game in the MOMOverse.  With simple to use APIs, game developers can take advantage of everything the MOMOverse has to offer including free to play and play to earn ecosystem, NFT Marketplaces, MOMO NFTs and more.Got a great game but don’t know where to start? Check out the MOBOX METAfund.`},
                {title:`MOBOX DAG`, content:`Create and organize your own Decentralized Autonomous Guild.  Using trustless Smart Contracts, start your own MOMO community, share NFT resources, grow your treasury, and have fun and earn together.`},
            ]
        }
    },

    methods:{
        selectDetail(idx){
            this.selectIdx = idx;
        },
        getDt(idx){
            return this.liststart + this.listdt*idx
        },
    }
}
</script>

<style lang="less" scoped>
    .pageIn{
        .draw-pic{
            animation: inMask 1.5s forwards;
            animation-delay: 0.1s;
            animation-timing-function: steps(48);
        }
    }

    .paintview{
        position: relative;
        overflow: hidden;

        .paint-bg-1{
            position: absolute;
            width: 100%;
            top: 0;
        }

        padding: 214px 0 60px 0;

        .paintview-body{
            display: flex;
            margin-left: 7.5%;
            position: relative;
            width: 25%;

            .paint-line{
                height: 100%;
                max-height: 720px;
                margin-right: 45px;
            }

            .paintview-height{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .paint-list{
                list-style: none;
                margin: 0;
                padding: 0;

                li{
                    cursor: pointer;
                    margin-bottom: 50px;

                    .paint-list-title{
                        display: inline-block;
                        position: relative;

                        .h1{
                            position: relative;
                        }
                    }

                    .list-active{
                        position: absolute;
                        bottom: 3px;
                        
                        width: 100%;
                        height: 0;
                        border-width: 0px 10px 10px 0;
                        border-style: none solid solid;
                        border-color: transparent transparent #EFB513;

                        transition: 0.3s all;
                    }
                }
            }

            .paint-detail{
                position: relative;

                .paint-detail-box{
                    position: absolute;
                    bottom: 0;

                    .title{
                        line-height: 95px;
                        margin-bottom: 20px;
                    }
                }
            }
        }
        
        .paintview-pic{
            position: absolute;
            bottom: 60px;
            right: 0;

            width: 50%;
            height: 70%;

            .paintview-pic-box{

                width: 100%;
                height: 100%;
                
                
                .paintview-bottom{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    bottom: 0;

                    // background: url(../../assets/index/paintview/paint1.png);
                    // background-size: cover;
                }

                .paintview-cover{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    bottom: 0;

                    // background: url(../../assets/index/paintview/paint1g.png);
                    // background-size: cover;
                    
                    mask-image: url(../../assets/index/paintview/mask.png);
                    mask-size:4900% 100%;
                }
            }

        }
    }
</style>
